module.exports = __webpack_public_path__ + "static/img/carRental.7ba4148.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/carRental.png
// module id = JavS
// module chunks = 1